export function SiteFooter() {
  return (
    <footer>
      <p>
        Made with <span className="heart">♥</span> by{' '}
        <a href="https://aryanc403.com" target="_blank" rel="noreferrer">
          aryanc403
        </a>
      </p>
      <p className="footer-code">
        Built by competitive programmers, for competitive programmers. · A
        product by AlgoLifting
      </p>
    </footer>
  )
}
